<div class="main-page">
  <div class="login-form" [class]="{'is-edit-hub' : editFormIsHub}">
    <ng-container>
      @if (currentSection() === sectionENum.send) {
        <div class="login-title h1">Введите номер телефона</div>
        <form [formGroup]="phoneForm" class="login-block">
          <div class="some-input-and-label">
            <input
              [style]="phoneErrorMessage ? 'border-color: #E94848;' : ''"
              class="text-form"
              id="login"
              type="tel"
              inputmode="numeric"
              placeholder="+7 (___) ___-__-__"
              formControlName="phoneNumber"
              name="phoneNumber"
              phoneMaskForm
              [isFocusedCritical]="true"
              (focus)="onPhoneFocus()"
              (blur)="onPhoneBlur()"
              (input)="onPhoneInput()"
              [class]="{'input-error': phoneTouched && !phoneFocused && hasFieldError(phoneForm, 'phoneNumber') }"/>

              <div>
              @if(phoneErrorMessage){
                <span class="text-error">
              {{ phoneErrorMessage }}
                </span>
              }@else if(!phoneErrorMessage && phoneTouched && !phoneFocused && hasFieldError(phoneForm, 'phoneNumber')){
                <span class="text-error">
                Это поле обязательно для заполнения
                 </span>
              }
              </div>
          </div>

          <div class="block-agreements">
            <div class="offer-terms">
              <mat-pseudo-checkbox
                [state]="consentChecked ? 'checked' : 'unchecked'"
                class="mat-pseudo-checkbox"
                (click)="consentChecked = !consentChecked"
              ></mat-pseudo-checkbox>
              <span class="inter" style="max-width: 443px">
              Я принимаю условия
          <a href="https://onf.ru/policy" target="_blank" class="offer-link">
            Политики обработки персональных данных
          </a>
           </span>
            </div>

            <div class="offer-terms">
              <mat-pseudo-checkbox
                [state]="userAgreementChecked ? 'checked' : 'unchecked'"
                class="mat-pseudo-checkbox"
                (click)="userAgreementChecked = !userAgreementChecked"
              ></mat-pseudo-checkbox>
              <span class="inter" style="max-width: 443px">
            Я даю
          <a href="https://onf.ru/consent" target="_blank" class="offer-link">
           Согласие на обработку моих персональных данных
          </a>
           </span>
            </div>
            <div class="offer-terms">
              <mat-pseudo-checkbox
                [state]="personalDataChecked ? 'checked' : 'unchecked'"
                class="mat-pseudo-checkbox"
                (click)="personalDataChecked = !personalDataChecked"
              ></mat-pseudo-checkbox>
              <span class="inter" style="max-width: 443px">
           Я принимаю условия
          <a href="https://onf.ru/terms" target="_blank" class="offer-link">
          Пользовательского соглашения
          </a>
           </span>
            </div>
          </div>

          <app-button
            [disabled]="phoneForm.invalid || !consentChecked || !personalDataChecked || !userAgreementChecked"
            [title]="'Отправить код'"
            (click)="onPhoneSubmit(false)"
            type="submit"
            [isLoading]="isLoading()">
          </app-button>
        </form>
      } @else if (currentSection() === sectionENum.confirmMax) {
        <div class="code-block">
          <div class="header-block" >
            <button class="back-btn" (click)="goBack()" (mouseenter)="arrowMouseEnter()" (mouseleave)="arrowMouseLeave()" >
              @if(arrowFieldState()){
                <img src="/assets/images/login/arrow-small.svg" alt=""/>
              }@else {
                <img src="/assets/images/login/arrow.svg" alt=""/>
              }
            </button>
            <span class="uppercase gray step-confirm-max">Шаг 1</span>
            <h2 class="title h1">
              ПОЛУЧИТЕ КОД
            </h2>
            <div class="gr-code">
              <div  class="qr" #qrCode></div>
              <div class="desc-step-qr">
                <div class="item-step">
                   <span class="index-step">1</span>
                    @if(!adaptiv()){
                      <span class="desc-index-step desktop-desc-index-step">Перейдите в MAX с помощью сканирования QR-кода или по кнопке ниже</span>
                    }@else{
                      <span class="desc-index-step desktop-desc-index-step">Перейдите в MAX  по кнопке ниже</span>
                    }

                </div>

                <div class="item-step">
                  <span  class="index-step">2</span>
                  <span class="desc-index-step">Запустите чат-бот и следуйте инструкции, если не запускали его ранее</span>
                </div>

                <div class="item-step">
                  <span  class="index-step">3</span>
                  <span class="desc-index-step">Скопируйте код и введите его на этой странице</span>
                </div>
              </div>
            </div>
            <div class="bth-max">
              <app-button
                [title]="'Перейти в MAX'"
                (click)="goToMax()">
              </app-button>
            </div>
          </div>

          <div class="header-block">
            <span class="uppercase gray step-confirm-max">Шаг 2</span>
            <h2 class="title h1">
              ПОДТВЕРДИТЕ ВХОД
            </h2>
          </div>
          <form [formGroup]="codeForm" class="login-block">
            <div class="some-input-and-label">
              <input
                [style]="errorMessage() ? 'border-color: #E94848;' : ''"
                class="text-form code"
                id="code"
                type="number"
                autoFocus-fieldCode
                [placeholder]="isFocused ? '' : 'Введите код'"
                (focus)="isFocused = true"
                (blur)="isFocused = false"
                formControlName="code"
                name="code"
                mask="0000"
                (keydown)="onKeyDown($event)"
                (wheel)="$event.preventDefault()"
                (change)="errorMessage.set(null)"
                [class]="{ 'input-error': !isFocused && hasFieldError(codeForm, 'code') }"
              />
              @if (errorMessage() || !errorMessage() && !isFocused && hasFieldError(codeForm, 'code')) {
                <div>
                  @if(errorMessage()){
                <span class="text-error">
                    {{ errorMessage() }}
                  </span>
                  }
                  @if(!errorMessage() &&  !isFocused && hasFieldError(codeForm, 'code') ){
                    <span class="text-error">Это поле обязательно для заполнения</span>
                  }
                </div>
              }
            </div>

            <app-button
              [title]="'Подтвердить'"
              (click)="onCodeSubmit(true)"
              type="submit"
              [isLoading]="isLoading()"
              [disabled]="codeForm.invalid">
            </app-button>
          </form>
        </div>
      } @else if (currentSection() === sectionENum.confirm) {
        <div class="code-block">
          <div class="header-block">
            <button class="back-btn" (click)="goBack()" (mouseenter)="arrowMouseEnter()" (mouseleave)="arrowMouseLeave()" >
              @if(arrowFieldState()){
                <img src="/assets/images/login/arrow-small.svg" alt=""/>
              }@else {
                <img src="/assets/images/login/arrow.svg" alt=""/>
              }
            </button>
            <h2 class="title h1">
              ПОДТВЕРДИТЕ НОМЕР
              <br/>ТЕЛЕФОНА
            </h2>
          </div>
          <h5 class="text-3 text-sended-code">
            На номер {{
              phoneForm.get("phoneNumber")?.value | phoneNumberFormat
            }}
            отправлен проверочный код
          </h5>
          <form [formGroup]="codeForm" class="login-block">
            <div class="some-input-and-label">
              <input
                autoFocus-fieldCode
                [style]="errorMessage() ? 'border-color: #E94848;' : ''"
                class="text-form code"
                id="code"
                type="number"
                [placeholder]="isFocused ? '' : 'Введите код'"
                (focus)="isFocused = true"
                (blur)="isFocused = false"
                formControlName="code"
                name="code"
                mask="0000"
                (keydown)="onKeyDown($event)"
                (wheel)="$event.preventDefault()"
                (change)="errorMessage.set(null)"
                [class]="{ 'input-error': !isFocused && hasFieldError(codeForm, 'code') }"/>

              @if (errorMessage() || !errorMessage() && !isFocused && hasFieldError(codeForm, 'code')) {
                <div>
                @if(errorMessage()){
                  <span class="text-error">
                {{ errorMessage() }}
              </span>
                }
                @if(!errorMessage() && !isFocused && hasFieldError(codeForm, 'code')){
                  <span class="text-error">Это поле обязательно для заполнения</span>
                }
                </div>
              }
            </div>

            <app-button
              [title]="'Подтвердить'"
              (click)="onCodeSubmit(false)"
              type="submit"
              [isLoading]="isLoading()"
              [disabled]="codeForm.invalid">
            </app-button>

            @if (timerStatus()) {
              <button class="get-code-btn" disabled>
                <span class="text-1 resend-code">Повторная отправка будет доступна через <br />
                  (@if (timer().hoursLeft) {
                    {{ timer().hoursLeft | number: '2.0' }}:
                  }

                  {{ timer().minutesLeft | number: '2.0' }}:
                  {{ timer().secondsLeft | number: '2.0' }}
                  )
                </span>
              </button>
            } @else {
              <app-button
                [title]="'Отправить код повторно'"
                [variant]="'outline'"
                (click)="onPhoneSubmit(true)"
              />
            }
          </form>
        </div>
      } @else if (currentSection() === sectionENum.fields) {
        <required-fields-form
          (fieldsSavedSuccess)="fieldsSavedSuccess = $event"
          (fieldsPassed)="authorize()"
          [fields]="actualfieldsData()">
        </required-fields-form>
      } @else if (currentSection() === sectionENum.edit) {
        <edit-fields-form
          [fields]="editFields"
          [isCancelWindowOpen]="isEditCancelled"
          (isCancelText)="isCancelEditText = $event"
          (canceledCancelEdit)="canceledCancelEdit()"
          (editHubIs)="editHubIs($event)"
          (redirectToBack)="redirectToClient()">
        </edit-fields-form>
      } @else if (currentSection() === sectionENum.fieldsSaved) {
        <p class="h1 black uppercase text-center">
          Данные успешно изменены
        </p>
        <app-button
          (click)="authorize()"
          [title]="'Завершить редактирование'">
        </app-button>
      } @else if (currentSection() === sectionENum.auth) {
      }
    </ng-container>

  </div>
  @if (currentSection() === sectionENum.confirmMax){
    <span class="black uppercase go-to-standard-confirm" (pointerdown)="goToStandardConfirm();$event.preventDefault()">Отправить код в СМС</span>
  }
  @if (isCancelEditText) {
    <div class="cancel-button" [class]="{'is-edit-hub' : editFormIsHub}">
      <span class="cancel-text uppercase black" (click)="cancelEdit()">Отменить редактирование</span>
    </div>
  }
</div>
<cookie-popup></cookie-popup>
<hidden-captcha [relodCaptchaTrigger]="reloadCaptchaTrigger" (captcha)="onCapchaPassed($event)">
</hidden-captcha>
